import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {selectStore} from "../../../store/selector";
import dayjs from "dayjs";
import {Card, Form, message, Row, Col, Image, Spin} from "antd";
import {StyledAdmissionNotes} from "./index.styles";
import {
  fetchCollegeAndExecutorAction,
  fetchEducationEditOrderAction,
  fetchGetInfoAction,
  fetchSetSpecialityStatusAction
} from "../../../store/pages/admission/actions";
import {StyledButton} from "../AdmissionWithoutRanking/index.styles";
import {EdsButton} from "../../../components/pages/Entrant/ExecutorApplication/EdsButton";
import {AdmissionAcceptForm, AdmissionDeleteForm, AdmissionRejectForm, AdmissionRevokeForm} from "../../../components";
import {decodeBase64} from "../../../utils/decodeBase64";
import {encodeBase64} from "../../../utils/encodeBase64";

export const AdmissionNotes = () => {
  let {id} = useParams();
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {t} = useTranslation(["admissionNotes", "executorAdmissionSteps"]);

  id = decodeBase64(id)

  const {profile: {userProfile: profileData}, admission: {getInfo, collegeAndExecutor}} = useSelector(selectStore);

  let collegeAndExecutorData = collegeAndExecutor.data

  const [formData, setFormData] = useState({
    reason: null,
    comment: '',
    date: dayjs().format('DD.MM.YYYY'),
    decline_reason: '',
    note_number: '',
    phone: ''
  });
  const [disabled, setDisabled] = useState(false);
  const [disabledAddress, setDisabledAddress] = useState(false);


  useEffect(() => {
    if(collegeAndExecutor.data && collegeAndExecutor.data.educationOrder && collegeAndExecutor.data.educationOrder.college && !collegeAndExecutor.data.educationOrder.college.address){
      setDisabledAddress(true)
      message.error("В организации не указан адрес учреждения")
    } else {
      setDisabledAddress(false)
    }

    if(collegeAndExecutor.data && collegeAndExecutor.data.educationOrder && !collegeAndExecutor.data.educationOrder.executor){
      setDisabled(true)
      message.error("В колледже не указан исполнитель, добавьте ФИО и телефон исполнителя!")
      if(collegeAndExecutor.data.educationOrder.executor && !collegeAndExecutor.data.educationOrder.executor.fio){
        setDisabled(true)
        message.error("Добавьте ФИО исполнителя!")
      }

      if(collegeAndExecutor.data.educationOrder.executor && !collegeAndExecutor.data.educationOrder.executor.phone){
        setDisabled(true)
        message.error("Добавьте телефон исполнителя!")
      }
    } else {
      setDisabled(false)
    }
  }, [collegeAndExecutor]);

  const [edit, setEdit] = useState(true);
  const [edsResult, setEdsResult] = useState(null as any);
  const [loading, setLoading] = useState(false);

  const [textToDisplay, setTextToDisplay] = useState('Генерация документа...');

  const currentTypeNote = searchParams.get("type");

  const reasonsList = t('executorAdmissionSteps:selectList', {returnObjects: true});

  const [acceptForm] = Form.useForm();
  const [rejectForm] = Form.useForm();
  const [revokeForm] = Form.useForm();
  const [deleteForm] = Form.useForm();

  useEffect(() => {
    // user_id
    // @ts-ignore
    dispatch(fetchGetInfoAction({education_order_id: id}))
    // @ts-ignore
    dispatch(fetchCollegeAndExecutorAction(id))
  }, [])

  let body = {
    id,
    status: currentTypeNote === 'accept' ? '2' : currentTypeNote === 'reject' ? '3' : currentTypeNote === 'delete' ? '6' : currentTypeNote === 'revoke' ? '5' : '',
    receipt_pdf_url: edsResult && edsResult.pdfFileUrl ? edsResult.pdfFileUrl : '',
    // user_id,
    decline_reason: formData.decline_reason ? formData.decline_reason : ''
  }


  useEffect(() => {
    if (edsResult) {
      // @ts-ignore
      dispatch(fetchEducationEditOrderAction(body))
      message.success(t('admissionNotes:ecp.saveNote'));
      if (currentTypeNote === 'revoke' || currentTypeNote === 'reject' || currentTypeNote === 'delete') {
        setTimeout(() => {
          // &user_id=${user_id}
          navigate(`/entrant-admission-view?education_order_id=${encodeBase64(id)}`, {replace: true})
        }, 1500)
      } else if (getInfo.data.educationOrder.education_form === '2' || getInfo.data.educationOrder.education_form === '3' || getInfo.data.educationOrder.education_type === '1' || getInfo.data.educationOrder.pay_form === '2') {
        setTimeout(() => {
          // &user_id=${user_id}
          // navigate(`/entrant-admission-without-ranking?education_order_id=${encodeBase64(id)}`, {replace: true})
          navigate(`/entrant-admission-view?education_order_id=${encodeBase64(id)}`, {replace: true})
        }, 1500)
      } else {
        setTimeout(() => {
          // &user_id=${user_id}
          navigate(`/entrant-admission-view?education_order_id=${encodeBase64(id)}`, {replace: true})
        }, 1500)
      }
    }
  }, [edsResult])


  const dataForXml = collegeAndExecutorData ? {
    title: `${currentTypeNote === 'accept' ? t('admissionNotes:acceptNote.title') : currentTypeNote === 'reject' ? t('admissionNotes:rejectNote.heading') : currentTypeNote === 'revoke' ? t('admissionNotes:revokeNote.heading') : currentTypeNote === 'delete' ? t('admissionNotes:deleteNote.heading') : 'Что-то с типом type'}`,
    [t('admissionNotes:nameAndAddress')]: collegeAndExecutorData?.educationOrder && collegeAndExecutorData?.educationOrder?.college?.name ? `${t('admissionNotes:school')} ${collegeAndExecutorData?.educationOrder ? (collegeAndExecutorData?.educationOrder?.college?.name + ', ' + collegeAndExecutorData?.educationOrder?.college?.address?.country?.caption + ', ' + collegeAndExecutorData?.educationOrder?.college?.address?.parent?.parent?.caption + ', ' + collegeAndExecutorData?.educationOrder?.college?.address?.parent?.caption + ', ' + collegeAndExecutorData?.educationOrder?.college?.address?.caption) : null}` : 'Что-то с college',
    // @ts-ignore
    [t('admissionNotes:rejectNote.receiptTitleForm')]: reasonsList[formData.reason],
    [t('admissionNotes:commentForm')]: formData.comment,
    [t('admissionNotes:executorContactPhone')]: collegeAndExecutorData?.educationOrder && collegeAndExecutorData?.educationOrder?.executor?.phone,
    [t('admissionNotes:dateOfReceipt')]: formData.date,
    footerEnd: `${t('admissionNotes:urLica')}`,
    footerLink: 'https://college.bilimal.kz/'
  } : null;

  const onValuesChange = (changedFields: any, allFields: any) => {
    setFormData(prevState => ({
      ...prevState, ...changedFields
    }))
  }

  const onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo);

    message.error(t('admissionNotes:errorEmpty'))
  };

  const handleStartSign = () => {
    setEdit(false)
    setLoading(true)
  }

  const handleStopSign = () => {
    setEdit(false)
    setLoading(false)
  }

  function edsResultHandler(result: any) {
    setEdsResult(result);
  }

  const handleJumpToOtherStatus = () => {
    getInfo && getInfo.data && getInfo.data.educationOrder.selectedSpecialities.map((item: any) => {
      // @ts-ignore
      dispatch(fetchSetSpecialityStatusAction({
        id: item.id,
        status: 32
      }))
    })
    setTimeout(() => {
      // @ts-ignore
      dispatch(fetchEducationEditOrderAction(body))
      message.success(t('admissionNotes:ecp.saveNote'));
      if (currentTypeNote === 'revoke' || currentTypeNote === 'reject' || currentTypeNote === 'delete') {
        setTimeout(() => {
          // &user_id=${user_id}
          navigate(`/entrant-admission-view?education_order_id=${encodeBase64(id)}`, {replace: true})
        }, 1500)
      } else if (getInfo.data.educationOrder.education_form === '2' || getInfo.data.educationOrder.education_form === '3' || getInfo.data.educationOrder.education_type === '1' || getInfo.data.educationOrder.pay_form === '2') {
        setTimeout(() => {
          // &user_id=${user_id}
          navigate(`/entrant-admission-view?education_order_id=${encodeBase64(id)}`, {replace: true})
          // navigate(`/entrant-admission-without-ranking?education_order_id=${encodeBase64(id)}`, {replace: true})
        }, 1500)
      } else {
        setTimeout(() => {
          // &user_id=${user_id}
          navigate(`/entrant-admission-view?education_order_id=${encodeBase64(id)}`, {replace: true})
        }, 1500)
      }
    }, 1000)
  }

  return (
    <Row justify='center'>
      <Col span={20}>
        <Row>
          <Col span={24} style={{paddingTop: 32, paddingBottom: 32}}>
            <Spin spinning={profileData.loading}>
              <StyledAdmissionNotes>
                <h3>{currentTypeNote === 'accept' ? t('admissionNotes:acceptNote.title') : currentTypeNote === 'reject' ? t('admissionNotes:rejectNote.heading') : currentTypeNote === 'revoke' ? t('admissionNotes:revokeNote.heading') : currentTypeNote === 'delete' ? t('admissionNotes:deleteNote.heading') : 'Что-то с типом type'}</h3>
                {!getInfo.loading && collegeAndExecutorData ? (
                  <Card>
                    <div className='headerNote'>
                      <p>{t('admissionNotes:serviceRecipient')}</p>
                      <p>{getInfo.data && getInfo.data.educationOrder ? (getInfo.data.educationOrder.parent_name ? (`${getInfo.data.educationOrder.parent_surname} ${getInfo.data.educationOrder.parent_name} ${getInfo.data.educationOrder.parent_patronymic_entrant}`)
                        : getInfo.data.educationOrder.name_entrant ? (`${getInfo.data.educationOrder.name_entrant} ${getInfo.data.educationOrder.surname_entrant} ${getInfo.data.educationOrder.patronymic_entrant}`) : 'smth with parent or entrant') : 'smth with entrant'}</p>
                      <p>{t('admissionNotes:iin')} {getInfo.data && getInfo.data.educationOrder ? (getInfo.data.educationOrder.iin_parent ? getInfo.data.educationOrder.iin_parent : getInfo.data.educationOrder.iin_entrant) : 'smth with entrant'}</p>
                    </div>
                    <h5>{currentTypeNote === 'accept' ? t('admissionNotes:acceptNote.heading')
                      : currentTypeNote === 'reject' ? t('admissionNotes:rejectNote.heading')
                        : currentTypeNote === 'revoke' ? t('admissionNotes:revokeNote.heading')
                          : currentTypeNote === 'delete' ? t('admissionNotes:deleteNote.heading') : 'Что-то с типом type'}</h5>
                    <p>{currentTypeNote === 'accept' ?
                      `${t('admissionNotes:school')} ${collegeAndExecutorData.educationOrder ?
                        (collegeAndExecutorData?.educationOrder?.college?.name + ', ' + collegeAndExecutorData?.educationOrder?.college?.address?.country?.caption + ', ' + collegeAndExecutorData?.educationOrder?.college?.address?.parent?.parent?.caption + ', ' + collegeAndExecutorData?.educationOrder?.college?.address?.parent?.caption + ', ' + collegeAndExecutorData?.educationOrder?.college?.address?.caption)
                        : null}`
                      : currentTypeNote === 'reject' ? `${t("rejectNote.receiptLongText", {
                          collegeName: collegeAndExecutorData?.educationOrder ? (collegeAndExecutorData?.educationOrder?.college?.name + ', ' + collegeAndExecutorData?.educationOrder?.college?.address?.country?.caption + ', ' + collegeAndExecutorData?.educationOrder?.college?.address?.parent?.parent?.caption + ', ' + collegeAndExecutorData?.educationOrder?.college?.address?.parent?.caption + ', ' + collegeAndExecutorData?.educationOrder?.college?.address?.caption)
                            : null
                        })}`
                        : (currentTypeNote === 'delete' || currentTypeNote === 'revoke') ? '' : 'Что-то с типом type'}</p>

                    {
                      currentTypeNote === 'reject' ?
                        <AdmissionRejectForm formRef={rejectForm} formData={formData} infoOfOrder={getInfo}
                                             onValuesChange={onValuesChange}
                                             executorData={collegeAndExecutorData.educationOrder} edit={edit}
                        />
                        : currentTypeNote === 'accept' ?
                          <AdmissionAcceptForm formRef={acceptForm} formData={formData} infoOfOrder={getInfo}
                                               onValuesChange={onValuesChange}
                                               executorData={collegeAndExecutorData.educationOrder} edit={edit}
                          />
                          : currentTypeNote === 'revoke' ?
                            <AdmissionRevokeForm formRef={revokeForm} formData={formData}
                                                 onValuesChange={onValuesChange}
                                                 executorData={collegeAndExecutorData.educationOrder} edit={edit}
                            />
                            : currentTypeNote === 'delete' ?
                              <AdmissionDeleteForm formRef={deleteForm} formData={formData}
                                                   onValuesChange={onValuesChange}
                                                   executorData={collegeAndExecutorData.educationOrder} edit={edit}
                                // dateOfNote={dateOfNote}
                                // setDateOfNote={setDateOfNote}
                              />
                              : 'smth with type'
                    }

                    {currentTypeNote === 'revoke' || currentTypeNote === 'delete' ? null :
                      <div className="modalSign mt-3">

                        {
                          (edsResult) ? (
                            <div>
                              <span className="signTitle">{t('admissionNotes:ecp.statusAccpet')}</span>
                              <p className="signSubTitle">{t('admissionNotes:ecp.warning')}</p>
                              <p className="signSubTitle">{t('admissionNotes:ecp.qr')}</p>
                              <div className='d-flex' style={{marginLeft: '32px', marginTop: '6px'}}>
                                {edsResult.qrImages.map((qrImage: any, idx: any) => (
                                  <div style={{marginLeft: '10px'}}>
                                    {/*@ts-ignore*/}
                                    <Image key={idx + 'qr-code'} onClick={() => {
                                      const newWindow: any = window.open('admissionNotes:about:blank', '');
                                      newWindow.document.write(`<img src="${qrImage}" alt="qr-codes" />`);
                                    }} src={qrImage} style={{width: '8rem', height: '8rem'}}/>
                                  </div>
                                ))}
                              </div>
                              <p>{t('admissionNotes:ecp.xml')}</p>
                              <a target='_blank' href={process.env.REACT_APP_SITE_URL + edsResult.pdfFileUrl}
                                 className="btn btn-success btn-signature">{t('admissionNotes:ecp.pdf')}</a>
                            </div>
                          ) : (
                            <div>
                              {loading === true ? textToDisplay : (

                                <div>
                                  <span className="signTitle">{t('admissionNotes:ecp.error')}</span>
                                  <p className="signSubTitle">{t('admissionNotes:ecp.warning')}</p>
                                  {(process.env.REACT_APP_ENV !== 'production') && <StyledButton
                                      style={{marginBottom: 12}} type="primary"
                                      onClick={() => handleJumpToOtherStatus()}>Подписать без ЭЦП
                                  </StyledButton>}
                                  <EdsButton disabled={disabledAddress || disabled} onClick={() => console.error('admissionNotes:click')}
                                             tplName={currentTypeNote === 'reject' ? 'documents-refusal' : currentTypeNote === 'accept' ? 'documents-receiving' : currentTypeNote === 'revoke' ? '' : message.error('admissionNotes:Неизвестный тип документа')}
                                             tplData={{
                                               fio: getInfo.data && getInfo.data.educationOrder ? (getInfo.data.educationOrder.parent_name ? (`${getInfo.data.educationOrder.parent_surname} ${getInfo.data.educationOrder.parent_name} ${getInfo.data.educationOrder.parent_patronymic_entrant}`)
                                                 : getInfo.data.educationOrder.name_entrant ? (`${getInfo.data.educationOrder.name_entrant} ${getInfo.data.educationOrder.surname_entrant} ${getInfo.data.educationOrder.patronymic_entrant}`) : 'smth with parent or entrant') : 'smth with entrant',
                                               iinParent: getInfo.data && getInfo.data.educationOrder && getInfo.data.educationOrder.iin_parent,
                                               iinEntrant: getInfo.data && getInfo.data.educationOrder && getInfo.data.educationOrder.iin_entrant,
                                               // @ts-ignore
                                               reason: reasonsList[formData.reason],
                                               comment: formData.comment,
                                               // @ts-ignore
                                               telephone: collegeAndExecutorData.educationOrder && collegeAndExecutorData.educationOrder.college.phone,
                                               collegeName: collegeAndExecutorData.educationOrder && collegeAndExecutorData.educationOrder.college.name,
                                               executor: collegeAndExecutorData.educationOrder && collegeAndExecutorData.educationOrder.executor ? collegeAndExecutorData.educationOrder.executor.fio : 'Исполнитель не найден',
                                               date: formData.date,
                                               numberApplication: formData.note_number
                                             }}
                                             infoOfOrder={getInfo}
                                             egovReason={currentTypeNote === 'accept' ? '-1' : currentTypeNote === 'reject' ? formData.reason : message.error('error with reason')}
                                             egovDeclineOtherReason={formData.comment}
                                             dataForXml={dataForXml} keyType={'SIGNATURE'}
                                             edsResultHandler={edsResultHandler}
                                             handleStart={handleStartSign} handleStop={handleStopSign}
                                             setTextToDisplay={setTextToDisplay}
                                             onFinishFailed={onFinishFailed}
                                             refForm={
                                               currentTypeNote === 'reject' ? rejectForm
                                                 : currentTypeNote === 'accept' ? acceptForm
                                                   : message.error('admissionNotes:Странный тип note')
                                             }/>
                                </div>
                              )}
                            </div>
                          )
                        }
                      </div>
                    }


                  </Card>
                ) : 'Loading...'}


                <Row justify='center' style={{marginTop: 16}}>
                  <StyledButton style={{marginRight: 16}}
                                onClick={() => navigate(-1)}>{t('admissionNotes:ecp.cancel')}</StyledButton>
                  {edsResult || currentTypeNote === 'revoke' || currentTypeNote === 'delete' ? null : (edit ?
                    <StyledButton
                      onClick={() => setEdit(prevState => !prevState)}>{t('admissionNotes:ecp.view')}</StyledButton> :
                    <StyledButton disabled={loading}
                                  onClick={() => setEdit(prevState => !prevState)}>{t('admissionNotes:ecp.edit')}</StyledButton>)}
                </Row>
              </StyledAdmissionNotes>
            </Spin>
          </Col>
        </Row>
      </Col>
    </Row>
  )
}